import { v4 as uuidv4 } from 'uuid';

export function SellerSimulateShipping(props = {}, childrenComponents = []) {
	return {
		componentName: 'SellerSimulateShipping',
		componentId: uuidv4(),
		title: '',
		props: Object.assign({}, props),
		childrenComponents,
	};
}
